import Core from 'core/js/pages/municipality/index.js'

// @vue/component
export default Vue.extend({
  extends: Core,
  name: 'municipality-page-custom-gc',
  computed: {
    items() {
      let items = [
        {
          value: HOME_ROUTE,
          icon: 'inicio',
          label: this.$t('defaultLayout.options.home')
        },
        {
          value: 'municipality-routes',
          icon: 'lineas',
          label: this.$t('defaultLayout.options.routes'),
        },
        {
          value: 'municipality-stops',
          icon: 'paradas',
          label: this.$t('defaultLayout.options.stops'),
        },
        {
          value: 'municipality-point-of-sales',
          icon: 'ventas',
          label: this.$t('defaultLayout.options.sales'),
        },

        {
          value: 'municipality-movements-history',
          icon: 'movements',
          label: this.$t('defaultLayout.options.movementsHistory'),
        },
        {
          value: 'municipality-recharge',
          icon: 'recargar',
          label: this.$t('defaultLayout.options.recharge'),
        },
        {
          value: 'municipality-news',
          icon: 'warnings',
          label: this.$t('defaultLayout.options.notices'),
        },
        {
          value: 'municipality-faqs',
          icon: 'news',
          label: this.$t('defaultLayout.options.news'),
        },
        {
          value: 'municipality-network-map',
          icon: 'mapa',
          label: this.$t('defaultLayout.options.networkMap'),
        },
        {
          value: 'info-cards',
          icon: 'infoCard',
          label: this.$t('defaultLayout.options.infoCard'),
        }
      ]

      /** Only if user logged in */
      if (this.currentUser) {
        items.push({
          value: 'municipality-service-channel',
          icon: 'soporte',
          label: this.$t('menu.serviceChannel'),
        })
      }

      if (this.administrativeArea.config.planner_with_map) {
         items.push({
          value: 'municipality-planner',
          icon: 'planner',
          label: this.$t('defaultLayout.options.planner')
        })
      }

      return items;
    }
  }
})
